import React, { Fragment } from "react";
import { Seo, Breadcrumb, ScrollTopBtn } from "../components";
import {
  HeaderThree,
  ServiceFour,
  AboutSeven,
  // TeamTwo,
  TestimonialThree,
  CtaOne,
  // BlogFour,
  FooterTwo,
} from "../containers";

const About = () => (
  <Fragment>
    <Seo 
  title="About Us - Tech Ayukta"
  description="Discover Tech Ayukta, a leading IT solutions and software development company delivering Web Development, App Development, ERP Solutions, SAP Training, Cloud Services, Digital Transformation, and IT Consulting with innovative, scalable, and enterprise-ready technologies."
  keywords="
    Tech Ayukta, 
    About Tech Ayukta, 
    IT Solutions Company, 
    Software Development Company, 
    Web Development Services, 
    Mobile App Development, 
    ERP Solutions, 
    SAP Services, 
    SAP Training Partner, 
    Cloud Computing Services, 
    Digital Transformation Company, 
    IT Consulting Services, 
    Custom Software Development, 
    Enterprise Application Development, 
    Full-Stack Development, 
    MERN Stack Development, 
    UI UX Design Services, 
    Backend Development, 
    Frontend Development, 
    API Development, 
    IT Outsourcing Company, 
    Technology Company in India, 
    Best IT Company, 
    SaaS Development Company, 
    CRM Development, 
    IT Infrastructure Services
  "
  canonical="https://www.techayukta.com/about"
/>


    <HeaderThree />
    <Breadcrumb
      pageName="About Us"
      bgImage="/images/breadcumb/breadcumb-bg.jpg"
    />
    <ServiceFour className="space-top space-extra-bottom" />
    <AboutSeven />
    {/* <TeamTwo className="space-top space-extra-bottom"/> */}
    <TestimonialThree className="space-top space-extra-bottom" />
    <CtaOne className="space" />
    {/* <BlogFour className="space-top space-extra-bottom"/> */}
    <FooterTwo />
    <ScrollTopBtn />
  </Fragment>
);

export default About;
